import styled from 'styled-components';
import {
  themeGet,
  space,
  SpaceProps,
  color,
  ColorProps,
  fontSize,
  FontSizeProps,
  width,
  WidthProps,
  minWidth,
  MinWidthProps
} from 'styled-system';
import { KeyboardArrowUp } from 'styled-icons/material/KeyboardArrowUp';
import { StyledButton } from 'src/kit';

export const StyledContainer = styled.div<SpaceProps>`
  position: relative;
  ${space};
`;

export const StyledCaret = styled(KeyboardArrowUp)``;

export const StyledToggle = styled(StyledButton)<{ isOpen: boolean; disabled?: boolean }>`
  cursor: ${({ disabled }) => (!disabled ? 'pointer' : 'not-allowed')};

  & ${StyledCaret} {
    transform: ${props => (props.isOpen ? 'none' : 'rotate(180deg)')};
  }
`;

export const StyledMenu = styled.ul<SpaceProps & WidthProps & MinWidthProps & ColorProps & FontSizeProps>`
  margin: 0;
  padding: 8px 0px 14px;
  background-color: ${themeGet('colors.white')};
  border-radius: 4px;
  box-shadow: 0px 2px 4px 0px rgba(22, 24, 31, 0.35);
  list-style: none;
  z-index: 100;
  ${space};
  ${width};
  ${minWidth};
  ${color};
  ${fontSize};
`;

export const StyledItem = styled.li`
  padding: 4px 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;
  ${color};
  &:hover {
    background-color: #f6f8f8;
  }
`;
